import SocialButtonsBaseView from './SocialButtonsBaseView';

export default class CoverSocialButtonsView extends SocialButtonsBaseView {

  view(ctrl){
    super.view(ctrl);
    return this.getSocialButtonViews();
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/socialButtons/CoverSocialButtonsView.js